import React from "react";
import { Header } from "../../../components/Header";
import { JoinusDetail } from "../../../blocks/joinus-detail";
import "./styles.less";
import { Footer } from "../../../components/Footer";
// import { useParams } from "react-router-dom";

export const JobDetail = () => {
  return (
    <div className="job-detail">
      <Header />
      <JoinusDetail />
      <Footer />
    </div>
  );
};
